<!-- Mobile View -->
<ul class="d-lg-none mobile-grid" *ngIf="userRequests?.length > 0 && !isLoading">
    <li class="item" *ngFor="let userRequest of userRequests">
        <div class="row">
            <div class="col-12">
                <request-progress [request]="userRequest"></request-progress>
            </div>
        </div>
        
        <div class="row">
            <div class="col-12 mobile-row">
                <user-request-managing-user-icon innerClass="me-1" [userRequest]="userRequest"></user-request-managing-user-icon>
                <strong>{{ userRequest.LastName }}, {{ userRequest.FirstName }}</strong>
            </div>
        </div>
        
        <div *ngIf="userRequest.Description?.trim()" class="row">
            <div class="col-12 mobile-row">
                <strong>Description:</strong> {{ userRequest.Description?.trim() }}
            </div>
        </div>
        
        <div class="row">
            <div class="col-12 mobile-row">
                <strong>Status:</strong> {{ userRequest.StatusLabel }}
            </div>
        </div>
        
        <div *ngIf="userRequest.ManagingUserID != userRequest.UserID" class="row">
            <div class="col-12 mobile-row">
                <span><strong>Managing User:</strong> {{ userRequest.ManagingUserLastName }}, {{ userRequest.ManagingUserFirstName }}</span>
            </div>
        </div>
        <div *ngIf="showFlexColumn" class="row">
            <div class="col-12 mobile-row">
                <strong>Flex:</strong> {{ userRequest.FlexItemLabel }}
            </div>
        </div>
        
        <div *ngIf="showAct48Column" class="row">
            <div class="col-12 mobile-row">
                <span class="badge bg-dark cpl-pill-border cpl-border-dark">
                    <i class="far fa-clock" aria-hidden="true"></i> 
                    Act 48 ({{ a48HelpersService.getHoursOrCreditsLabel(userRequest.Act48UserSubmissionDetails?.Hours, userRequest.Act48UserSubmissionDetails?.ActivityType) }})
                </span>
            </div>
        </div>   
        <div *ngIf="CanViewEvidenceDetails" class="d-flex flex-row align-items-center w-100 pt-3">
            <strong>Evidence:</strong>
            <user-request-item-evidence
                [requestItem]="requestItem"
                [userRequest]="userRequest"
                (onRefreshList)="refreshList()">
            </user-request-item-evidence>
        </div>
        <div class="w-100 gap-2">
            <user-request-action-button
                class="d-flex flex-row w-100 mt-3"
                [ngStyle]="{ '--user-request-actions-button-width': '100%' }"
                [requestItem]="completeRequestItem || requestItem"
                [userRequest]="userRequest"
                [type]="actionType"
                (onRefreshList)="refreshList()">
            </user-request-action-button>
            <user-request-action-button
                class="d-flex flex-row w-100 mt-3"
                [ngStyle]="{ '--user-request-actions-button-width': '100%' }"
                [requestItem]="requestItem"
                [userRequest]="userRequest"
                [type]="CplRosterActionsTypes.APPROVE"
                (onRefreshList)="refreshList()"
            ></user-request-action-button>
            <!-- EDLP-3580: Cancel from this page always requires a reason, in both My Items and All Users Progress. -->
            <a *ngIf="requestHelpersService.canViewUserRequestPage(userRequest)"
                class="btn btn-info w-100 mt-3"
                uiSref="authenticated.requests.open-request-item"
                [uiParams]="getViewParams(userRequest)">View</a>
        </div>
    </li>
</ul>

<!-- Desktop Table View -->
<div class="row d-none d-lg-block" *ngIf="userRequests?.length > 0 && !isLoading">
    <div class="col-sm-12">
        <table class="table table-striped roster" role="table" aria-label="Submitted requests">
            <thead>
                <tr>
                    <th scope="col" class="text-center fit"></th>
                    <th scope="col" class="no-wrap"><sort-by label="Request Description" [field]="SubmissionsSortField.Description"></sort-by></th>
                    <th scope="col"><sort-by label="Last Updated" [field]="SubmissionsSortField.LastUpdated"></sort-by></th>
                    <th scope="col"><sort-by label="Submitted" [field]="SubmissionsSortField.Submitted"></sort-by></th>
                    <th *ngIf="!!requestItem.FollowupRequired" scope="col"><sort-by label="Follow-up Due Date" [field]="SubmissionsSortField.FollowUpDueDate"></sort-by></th>
                    <th scope="col"><sort-by label="Manager" [field]="SubmissionsSortField.Manager"></sort-by></th>
                    <th scope="col" class="fit" *ngIf="showFlexColumn">Flex</th>
                    <th scope="col" class="fit" *ngIf="showAct48Column">Act 48</th>
                    <th *ngIf="CanViewEvidenceDetails" scope="col" class="text-center fit"></th>
                    <th scope="col" class="text-center fit">Actions</th>
                    <th *ngIf="shouldShowColumn(SubmissionActionType.APPROVE) && !isMyItems" scope="col" class="text-center fit"></th>
                    <th *ngIf="shouldShowColumn(SubmissionActionType.VIEW)" scope="col" class="text-center fit"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let userRequest of userRequests">
                    <td class="text-center">
                        <request-progress [request]="userRequest"></request-progress>
                    </td>
                    <td>
                        {{ userRequest.Description?.trim() || 'No description' }}
                    </td>

                    <td>
                        {{ userRequest.ModifiedDate | dateExtended:'MM/dd/yyyy hh:mm a' }}
                    </td>

                    <td>
                        {{ userRequest.SubmissionDate | dateExtended:'MM/dd/yyyy hh:mm a' }}
                    </td>

                    <td *ngIf="!!requestItem.FollowupRequired">
                        {{ userRequest.FollowupDueDate | dateExtended:'MM/dd/yyyy' }}
                    </td>

                    <td class="text-center fit">
                        <user-request-managing-user-icon [userRequest]="userRequest" [config]="{ popoverType: 'both' }"></user-request-managing-user-icon>
                    </td>

                    <td class="text-center fit" *ngIf="isFlexItem()">
                        <span>{{getFlexHours(userRequest)}}</span>
                    </td>

                    <td class="text-center fit" *ngIf="isAct48Enabled() && userRequest.Act48UserSubmissionDetails">
                        <timetracking-status-indicator
                            *ngIf="userRequest.Act48UserSubmissionDetails"
                            [userRequest]="userRequest"
                            [requestItem]="requestItem"
                            [timeTrackingType]="TimeTrackingType.ACT48"
                            [isUser]="isMyItems"
                            (onIconClick)="openAct48Modal(userRequest)">
                        </timetracking-status-indicator>
                        <small *ngIf="userRequest.Act48UserSubmissionDetails && userRequest.Act48UserSubmissionDetails.Hours">
                            ({{ a48HelpersService.getHoursOrCreditsLabel(userRequest.Act48UserSubmissionDetails.Hours, userRequest.Act48UserSubmissionDetails.ActivityType) }})
                        </small>
                        <span *ngIf="!userRequest.Act48UserSubmissionDetails" class="text-muted">—</span>
                    </td>

                    <td *ngIf="CanViewEvidenceDetails" class="text-center fit">
                        <user-request-item-evidence
                            [requestItem]="requestItem"
                            [userRequest]="userRequest"
                            (onRefreshList)="refreshList()">
                        </user-request-item-evidence>
                    </td>

                    <td class="text-center fit">
                            <user-request-action-button
                                [requestItem]="completeRequestItem || requestItem"
                                [userRequest]="userRequest"
                                [type]="actionType"
                                (onRefreshList)="refreshList()">
                            </user-request-action-button>
                    </td>

                    <td *ngIf="shouldShowColumn(SubmissionActionType.APPROVE) && !isMyItems" class="text-center fit">
                        <user-request-action-button
                            *ngIf="canShowApproveButton(userRequest)"
                            [requestItem]="requestItem"
                            [userRequest]="userRequest"
                            [type]="CplRosterActionsTypes.APPROVE"
                            (onRefreshList)="refreshList()">
                        </user-request-action-button>
                        <div *ngIf="!canShowApproveButton(userRequest)" class="user-request-action-spacer" aria-hidden="true"></div>
                    </td>

                    <td *ngIf="shouldShowColumn(SubmissionActionType.VIEW)" class="text-center fit">
                        <!-- EDLP-3580: Cancel from this page always requires a reason, in both My Items and All Users Progress. -->
                        <a *ngIf="requestHelpersService.canViewUserRequestPage(userRequest)"
                            class="btn btn-info user-request-actions-button"
                            uiSref="authenticated.requests.open-request-item"
                            [uiParams]="getViewParams(userRequest)">View</a>
                        <div *ngIf="!requestHelpersService.canViewUserRequestPage(userRequest)" class="user-request-action-spacer" aria-hidden="true"></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Empty State -->
<div *ngIf="(!userRequests || userRequests.length === 0) && !isLoading" class="text-center py-4">
    <i class="fas fa-inbox fa-3x text-muted mb-3" aria-hidden="true"></i>
    <p class="text-muted">No submissions found.</p>
</div>

<!-- Loading State -->
 <div *ngIf="userRequests && isLoading" class="text-center py-4" aria-busy="true" aria-live="polite">
    <p class="mt-2 text-muted">Loading submissions...</p> 
</div>